import type { HTMLAttributes } from "react";
import { cx } from "./cx";

export type StackGap = "sm" | "md" | "lg";

/** Vertical layout whose children always receive tokenized sibling spacing. */
export function Stack({ gap = "md", className, ...props }: HTMLAttributes<HTMLDivElement> & { gap?: StackGap }) {
  return <div className={cx("pz-stack", `pz-stack--${gap}`, className)} {...props} />;
}
